import PaginationFootballProperties from "../../../../Football/Models/Pagination/PaginationFootballProperties";
import ClassicQuizFiltersMeta from "./ClassicQuizFiltersMeta";

export default class ClassicQuizLeaderboardMeta {
  public pagination: PaginationFootballProperties =
    new PaginationFootballProperties();
  public filters: ClassicQuizFiltersMeta = new ClassicQuizFiltersMeta();
}
